export const fetchSwaggerEndpoints = async (swaggerUrl: string) => {
  try {
    const response = await fetch(swaggerUrl);
    if (!response.ok) {
      throw new Error("Failed to fetch Swagger endpoints");
    }
    const data = await response.json();
    // Parse and return endpoints as needed
    return data.paths; // Adjust based on Swagger structure
  } catch (error) {
    console.error("Error fetching Swagger endpoints:", error);
    return [];
  }
};